import styled, { css } from "styled-components"

function getVariants({ theme, $variant }) {
  const { colors, borders, spaces } = theme
  const { fg, bg } = colors[$variant]
  const { inline } = borders[$variant]

  return css`
    color: ${fg};
    background-color: ${bg};
    border: ${inline};
    padding: ${spaces.xtrasmall};
  `
}
/**
 * Clases are used here because we are out of the react flow for positioning
 */
export const TooltipContainer = styled.div`
  position: absolute;
  box-sizing: border-box;
  display: none;
  &.is-shown {
    display: block;
    &.being-positioned {
      display: none;
    }
  }
  &.is-placing {
    display: block;
    visibility: hidden;
  }
  ${getVariants}
`

export const TooltipAnchor = styled.span`
  cursor: pointer;
`
TooltipAnchor.defaultProps = {
  className: "tsr-tooltip",
}
